import React, { Component } from 'react';

import { getParams, pushUrl } from '../../../../utils/functions'

class Export extends Component {
  constructor(props) {
    super(props);

    const activeTabID = getParams('tab_id') ? getParams('tab_id') : 0;

    this.state = {
      activeTab: activeTabID === null ? 0 : activeTabID
    };
  }

  componentDidMount() {
  }

  updateValue = (id) => {
    this.setState({
      activeTab: id
    });

    pushUrl('탭', 'admin.php?page=researchmind-import&record_id='+getParams('record_id')+'&tab_id='+id, null);
  }

  render() {
    const { updateValue } = this;

    const tempStyle = {
      display: "inline-table",
      width: "25%"
    }
    return (
      <>
        <div className="container-fluid mt-3 detail-wrap">
          <div className="form-row ml-2 mb-2">
            <select style={{marginRight: '20px'}}>
              <option>반출포맷 : JCR</option>
            </select>
            <div className="btn-group" role="group" aria-label="Basic example" >
              <button type="button" className="btn btn-secondary btn-sm">다운로드</button>
              <button type="button" className="btn btn-secondary btn-sm">삭제</button>
            </div>
          </div>
          <br /><br />
          <div>
            <div style={tempStyle}>
              <h5><input type="checkbox" />저널 기본 정보</h5>
              <div><input type="checkbox" /><label>관리번호</label></div>
              <div><input type="checkbox" /><label>저널명</label></div>
              <div><input type="checkbox" /><label>ISSN</label></div>
              <div><input type="checkbox" /><label>eISSN</label></div>
              <div><input type="checkbox" /><label>출판국</label></div>
              <div><input type="checkbox" /><label>출판사</label></div>
              <div><input type="checkbox" /><label>언어</label></div>
              <div><input type="checkbox" /><label>링크</label></div>
            </div>
            <div style={tempStyle}>
              <h5><input type="checkbox" />저널 부가 정보</h5>
              <div><input type="checkbox" /><label>저널등급구분</label></div>
              <div><input type="checkbox" /><label>저널유형</label></div>
              <div><input type="checkbox" /><label>JCR ID</label></div>
              <div><input type="checkbox" /><label>WoS ID</label></div>
              <div><input type="checkbox" /><label>Scopus ID</label></div>
              <div><input type="checkbox" /><label>KCI ID</label></div>
              <div><input type="checkbox" /><label>OA 여부</label></div>
              <div><input type="checkbox" /><label>원문등록여부</label></div>
            </div>
            <div style={tempStyle}>
              <h5><input type="checkbox" />게재 학과 정보</h5>
              <div><input type="checkbox" /><label>단과대학</label></div>
              <div><input type="checkbox" /><label>학과</label></div>
              <div><input type="checkbox" /><label>전공</label></div>
            </div>
            <div style={tempStyle}>
              <h5><input type="checkbox" />평가지표 정보</h5>
              <div><input type="checkbox" /><label>IF(Impact Factor)</label></div>
              <div><input type="checkbox" /><label>ES(Eigen Score)</label></div>
              <div><input type="checkbox" /><label>SJR</label></div>
              <div><input type="checkbox" /><label>CitesScore</label></div>
              <div><input type="checkbox" /><label>KCI</label></div>
            </div>
          </div>
        </div>
      </>
    )
  }
}

export default Export